import * as React from 'react';

import ConfirmPurchaseModal from './ConfirmPurchaseModal';
import MainOfferModal from './MainOfferModal';
import { Renewal } from 'interface/offers';
import SelectOfferModal from './SelectOfferModal';
import { useState } from 'react';

interface IProps {
  renewal: Renewal;
  renewals: Renewal[];
  openRenewalModal: boolean;
  handleCloseRenewalModal: () => void;
}

enum eModalTypes {
  MAIN_OFFER = 'main offer',
  SELECT_OFFER = 'select offer',
  CONFIRM_PURCHASE = 'confirm purchase',
}

const RenewalModal = ({ renewal, renewals, openRenewalModal, handleCloseRenewalModal }: IProps) => {
  const [currentlOpenModal, setCurrentlOpenModal] = useState<eModalTypes>(eModalTypes.MAIN_OFFER);
  const [offer, setOffer] = React.useState('');

  const handleCheckIfPaymentIsPending = () => {
    const pendingRenewal = renewals.some((r) => r.payment_progress);

    if (pendingRenewal) {
      setCurrentlOpenModal(eModalTypes.CONFIRM_PURCHASE);
    } else {
      openRenewal();
      handleCloseCancel();
    }
  };

  const openRenewal = () => {
    window.open(renewal?.checkout_url, '_blank');
  };

  const openSelectOffer = () => {
    setCurrentlOpenModal(eModalTypes.SELECT_OFFER);
  };

  const handleChangeOffer = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOffer(event.target.value);
    renewal = renewals.find((r) => r.id.toString() === event.target.value);
  };

  const handleCloseCancel = () => {
    setOffer('');
    setCurrentlOpenModal(eModalTypes.MAIN_OFFER);
    handleCloseRenewalModal();
  };

  const moreThanOneOffer = renewals.length > 1;

  if (currentlOpenModal === eModalTypes.CONFIRM_PURCHASE) {
    return (
      <ConfirmPurchaseModal
        openRenewalModal={openRenewalModal}
        handleCloseCancel={handleCloseCancel}
        openRenewal={openRenewal}
      />
    );
  }

  if (currentlOpenModal === eModalTypes.SELECT_OFFER) {
    return (
      <SelectOfferModal
        renewals={renewals}
        openRenewalModal={openRenewalModal}
        offer={offer}
        handleCloseCancel={handleCloseCancel}
        handleChangeOffer={handleChangeOffer}
        handleCheckIfPaymentIsPending={handleCheckIfPaymentIsPending}
      />
    );
  }

  return (
    <MainOfferModal
      renewal={renewal}
      moreThanOneOffer={moreThanOneOffer}
      openRenewalModal={openRenewalModal}
      handleCloseCancel={handleCloseCancel}
      openSelectOffer={openSelectOffer}
      handleCheckIfPaymentIsPending={handleCheckIfPaymentIsPending}
    />
  );
};

export default RenewalModal;
